export const DEFAULT_PROPOSAL_FILTERS = Object.freeze({
  begin_date: '',
  end_date: '',
  multi_search: '',
  external_proposal_id: '',
  status: '',
  contract_status: '',
  contract_number: '',
  promoter_id: '',
  responsible_id: '',
  issue_type: '',
  supplier_id: '',
  purchaser_document_number: '',
  antifraud_completed: false,
  external_proposal_id_not_null: false,
  self_contracting: false,
  assignee: '',
  week_day: '',
  priority_level: '',
  with_shutdown: false,
});

export const DEFAULT_PROPOSAL_FILTERS_NAMES = Object.freeze({
  range: 'Período',
  multi_search: 'Cliente',
  external_proposal_id: 'CCB',
  status: 'Status',
  contract_status: 'Status',
  contract_number: 'N° do contrato',
  promoter_id: 'Promotor',
  responsible_id: 'Responsável',
  issue_type: 'Tipos de pendência',
  supplier_id: 'Banco',
  purchaser_document_number: 'Comprador',
  antifraud_completed: 'Formalizados',
  external_proposal_id_not_null: 'CCB Gerada',
  self_contracting: 'Auto-contratação',
  assignee: 'Cessionário',
  week_day: 'Dia da Semana',
  priority_level: 'Prioridade',
  with_shutdown: 'Apenas afastados',
});

export function createDefaultProposalFilters() {
  return { ...DEFAULT_PROPOSAL_FILTERS };
}

export function createDefaultProposalFiltersNames() {
  return { ...DEFAULT_PROPOSAL_FILTERS_NAMES };
}

export function buildContractManagementBackQuery(query = {}) {
  const { communication_id, ...rest } = query || {};

  return rest;
}
